import Adapter from 'enzyme-adapter-react-16';
import * as Enzyme from 'enzyme/build';

Enzyme.configure({ adapter: new Adapter() });
